// extracted by mini-css-extract-plugin
export default {"pageContent":"styles_pageContent__Z66GW","center":"styles_center__QzYmV","pagecontentStyles":"styles_pagecontentStyles__cIBwU","stickyFooter":"styles_stickyFooter__jAS2M"};